import styled from 'styled-components'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import type { BlacklistCurrenciesTableModel } from '../atoms/reatom-blacklist-currencies-table'
import type { ClassNameProps } from '@root/shared/react'

type BlacklistCurrenciesTableProps = {
  tableModel: BlacklistCurrenciesTableModel
} & ClassNameProps

export const BlacklistCurrenciesTable: React.FC<
  BlacklistCurrenciesTableProps
> = ({ className, tableModel }) => {
  return (
    <Root className={className}>
      <AppDataTable model={tableModel} rowHeight={40} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  min-height: 0;
`
